module.exports = __webpack_public_path__ + "img/ssyx_36.8e17d4e5.jpg";